import { getWidgetComponent } from "../get_widget_base";
import PieWidget from "./pie_widget";

export const getWidget = props =>
  getWidgetComponent({ ...props, widgetComp: PieWidget });
